// 横方向の指操作だけを縦→横の既存対応へ戻す。縦操作とピンチはブラウザに任せる。
export function initHorizontalSwipe(surface, { enabled, controller, positions, lenis, reducedMotion }) {
  let gesture;
  let suppressClick = false;
  const release = () => {
    const previous = gesture;
    gesture = undefined;
    if (previous && surface.hasPointerCapture?.(previous.id)) surface.releasePointerCapture(previous.id);
  };
  const down = (event) => {
    suppressClick = false;
    if (gesture) { release(); return; }
    if (!enabled() || !controller() || lenis.isStopped || event.isPrimary === false
      || !['touch', 'pen'].includes(event.pointerType)) return;
    gesture = { id: event.pointerId, x: event.clientX, y: event.clientY,
      position: controller().getState().position, horizontal: false };
  };
  const move = (event) => {
    if (!gesture || event.pointerId !== gesture.id) return;
    if (!enabled() || !controller() || lenis.isStopped) { release(); return; }
    const dx = event.clientX - gesture.x;
    const dy = event.clientY - gesture.y;
    const horizontal = controller();
    const { position, distance } = horizontal.getState();
    const target = Math.max(0, Math.min(gesture.position - dx, distance));
    if (!gesture.horizontal && Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
    // 出口を越えて縦に進んだ位置を、横移動の終端へ書き戻さない。
    if (position >= distance && target >= distance && dx < 0) { release(); return; }
    if (!gesture.horizontal) {
      if (Math.abs(dx) <= Math.abs(dy) * 1.2) { release(); return; }
      gesture.horizontal = true;
      suppressClick = true;
      surface.setPointerCapture?.(gesture.id);
    }
    event.preventDefault();
    lenis.scrollTo(horizontal.getScrollPosition(target), { immediate: true });
  };
  const up = (event) => {
    if (!gesture || event.pointerId !== gesture.id) return;
    const horizontal = controller();
    if (gesture.horizontal && enabled() && horizontal && !lenis.isStopped) {
      const { position, distance } = horizontal.getState();
      const stops = [...new Set([0, ...positions(), distance])].filter((value) => value >= 0 && value <= distance).sort((a, b) => a - b);
      let target = stops.reduce((nearest, value) => Math.abs(value - position) < Math.abs(nearest - position) ? value : nearest, stops[0]);
      const delta = gesture.x - event.clientX;
      if (delta > 32) target = Math.max(target, stops.find((value) => value > gesture.position + 1) ?? distance);
      if (delta < -32) target = Math.min(target, stops.findLast((value) => value < gesture.position - 1) ?? 0);
      // すでに揃っていれば待機区間の入口へ戻さず、そのまま縦操作へ渡す。
      if (Math.abs(target - position) > .01) {
        lenis.scrollTo(horizontal.getScrollPosition(target), { duration: .35, immediate: reducedMotion.matches });
      }
    }
    release();
  };
  const cancel = (event) => { if (gesture?.id === event.pointerId) release(); };
  const lostCapture = (event) => {
    // 子ボタンからsurfaceへ追跡を移す際の通知もバブルする。surface自身の解除だけを終了扱いにする。
    if (event.target === surface) cancel(event);
  };
  const click = (event) => {
    if (!suppressClick || event.detail === 0) return;
    suppressClick = false;
    event.preventDefault();
    event.stopImmediatePropagation();
  };
  surface.addEventListener('pointerdown', down);
  surface.addEventListener('pointermove', move, { passive: false });
  surface.addEventListener('pointerup', up);
  surface.addEventListener('pointercancel', cancel);
  surface.addEventListener('lostpointercapture', lostCapture);
  surface.addEventListener('click', click, true);
  return () => {
    release();
    surface.removeEventListener('pointerdown', down);
    surface.removeEventListener('pointermove', move);
    surface.removeEventListener('pointerup', up);
    surface.removeEventListener('pointercancel', cancel);
    surface.removeEventListener('lostpointercapture', lostCapture);
    surface.removeEventListener('click', click, true);
  };
}
